import React, { useEffect } from "react";
import FaLongArrowAltRight from "@react-icons/all-files/fa/FaLongArrowAltRight";
import { Link, useParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getBlogListApi } from "../../../redux/reduxApi/admin/BlogListReduxApi";
import Footer from "../homePage/components/footer/Footer";
import MyButton from "../utils/Button/MyButton";

export default function MainBlog() {
  const dispatch = useDispatch();
  const { categoryName } = useParams();
  const blogData = useSelector((state) => state.BlogList.getBlogList.blogs);
  console.log("this is blog data for website ", blogData);
  console.log("this is category data for website ", categoryName);
  useEffect(() => {
    const filterdata = {
      search: [
        {
          field: "categoryName",
          operation: "is",
          value: categoryName,
        },
      ],
    };
    if (categoryName) {
      dispatch(getBlogListApi(filterdata));
    } else {
      dispatch(getBlogListApi());
    }
  }, [dispatch, categoryName]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-blue-50 py-[20px] lg:py-[50px] lg:px-[7.3%]  ">
      <h1 className="text-center text-blue-900 font-bold w-full lg:text-5xl md:text-3xl text-2xl pb-2">
        Our Blogs
      </h1>
      <hr className="heading-seperator border-4 border-blue-900" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-black">
          {blogData &&
            blogData.length > 0 &&
            blogData.map((blog) => (
              <div
                key={blog.rowId}
                className="group bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300"
              >
                <Link to={`/blog/single-blog/${blog.rowId}`}>
                  <img
                    className="w-full h-52 sm:h-56 md:h-60 lg:h-55 object-cover group-hover:scale-105 transition-transform duration-500"
                    src={blog.uploadImage}
                    alt={blog.blogTitle}
                    onError={(e) => {
                      e.target.src =
                        "https://seocom.agency/wp-content/uploads/2024/05/Errores-Web-404-403-503-502-401.-Significado-y-soluciones-1.jpg";
                    }}
                  />
                </Link>

                <div className="p-4">
                  <Link to={`/blog/single-blog/${blog.rowId}`}>
                    <h1 className="mb-2 text-lg md:text-xl font-semibold text-start text-gray-900 line-clamp-2 cursor-pointer">
                      {blog.blogTitle}
                    </h1>
                  </Link>
                  <div
                    className="mb-3 text-sm md:text-base text-gray-700 line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: blog.description,
                    }}
                  />

                  <Link to={`/blog/single-blog/${blog.rowId}`}>
                    <h6 className="text-[#2772AD] text-sm md:text-base font-semibold hover:opacity-80">
                      Continue reading
                    </h6>
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
